import {MediaRepository} from "./media.repository";
import {MediaRepositoryV2} from "./media.repository.v2";

export type {MediaRepository} from "./media.repository";
export {MediaRepositoryV2} from "./media.repository.v2";

/**
 * Factory function to create the media repository.
 *
 * Always returns v2 — v2 has full parity for every media operation.
 * (Binary product content upload, formerly a v1-only exception, now goes
 * through DigitalProductRepositoryV2.uploadContent instead.)
 */
export const createMediaRepository = (): MediaRepository => {
  return new MediaRepositoryV2();
};

/**
 * Get v2 repository directly for portfolio image operations
 * (the only v2 endpoint currently available)
 */
export const getMediaRepositoryV2 = (): MediaRepositoryV2 => {
  return new MediaRepositoryV2();
};
